module.exports = __webpack_public_path__ + "img/logo.b8a51c52.svg";